import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { INotification } from '../types/Notification'

export const fetchNotifications = createAsyncThunk<
	INotification[],
	void,
	ThunkConfig<string>
>('fetchNotifications', async (_, thunkApi) => {
	const {
		extra: { api },
		rejectWithValue
	} = thunkApi

	try {
		const res = await api.get<INotification[]>(
			'/globalSettings/notifications'
		)

		return res.data
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchNotifications', 'Failed to fetch notifications')
		return rejectWithValue('Error occurred on fetching notifications')
	}
})
